import { Controller } from "@hotwired/stimulus"
import Logger from "../lib/logger"

// This controller allows you to easily dispatch a custom DOM event.
// It is particularly useful for bridging Turbo Streams with Javascript events.
//
// Usage:
// <div data-controller="event-dispatcher" data-event-dispatcher-name-value="custom:event"></div>
export default class extends Controller {
  static values = {
    name: String
  }

  connect() {
    if (this.nameValue) {
      Logger.debug(`[EventDispatcher] Dispatching event: ${this.nameValue}`)
      const event = new CustomEvent(this.nameValue, {
        bubbles: true,
        cancelable: true
      })
      this.element.dispatchEvent(event)
    } else {
      Logger.warn('[EventDispatcher] No event name provided')
    }
  }
}
